<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      label-width="120px"
    >
      <SpCardContent title="基础信息">
        <el-row>
          <el-col :span="16">
            <el-form-item label="导购人员：">
              <template v-if="showList.length <= 0">
                <el-button
                  icon="el-icon-plus"
                  type="primary"
                  @click="showBox = true"
                >
                  添加人员
                </el-button>
              </template>

              <template v-else>
                <div
                  class="el-button"
                  @click="showBox = true"
                >
                  <div class="guide-box">
                    <template v-for="(item, index) in showList">
                      <div
                        v-if="item.work_userid"
                        :key="index"
                        class="guide-number"
                      >
                        <img
                          v-if="item.salesperson_avatar"
                          :src="item.salesperson_avatar"
                          alt=""
                          class="pic"
                        >
                        {{ item.name }}
                      </div>

                      <div
                        v-else
                        :key="index"
                        class="guide-deparment"
                      >
                        <div class="pic-folder" />
                        {{ item.name }}
                      </div>
                    </template>
                  </div>
                </div>
              </template>
              <SpGuideBox
                v-model="showBox"
                :call-data="callData"
                @getUserList="getUserList"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </SpCardContent>

      <div class="welcome-box">
        <!-- <el-tabs v-model="target">
          <el-tab-pane label="会员欢迎语" name="1"></el-tab-pane>
          <el-tab-pane label="新客欢迎语" name="2"></el-tab-pane>
          <el-tab-pane label="老客非会员欢迎语" name="3"></el-tab-pane>
        </el-tabs> -->

        <SpWelcome
          :form="form"
          :is-show-type="isShowType"
        />
      </div>

      <div class="fotter-toolbar">
        <el-button
          type="primary"
          :loading="loading"
          @click="onSubmit"
        >
          立即创建
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      form: {
        channel_source: 0, //渠道来源：0新客，1社群，2活码
        work_userid: [],
        store_id: [],
        salesperson: {
          list: null
        },
        store: {
          list: null
        },

        text_msg: '',
        msg_type: 0, //消息类型：0图片，1链接，2小程序
        content: {
          image: {
            img_url: '',
            image_type: 'image/png'
          },
          link: {
            title: '链接',
            url: '',
            picurl: '',
            desc: ''
          },
          miniprogram: {
            title: '',
            img_url: '',
            page: '',
            image_type: 'image/png'
          }
        },
        attachments: [],
        target: 1
      },

      welcomeMsgId: 0,
      showBox: false,
      callData: {},
      showList: [],
      isShowType: true
    }
  },
  mounted () {
    let params = this.$route.params
    if (+params.id) {
      this.welcomeMsgId = params.id
      this.getInfo(params.id)
    }
  },
  methods: {
    // 获取详情
    async getInfo (id) {
      const data = await this.$api.customerConversion.getWelcomeInfo(id)

      if (data) {
        // 兼容老数据
        if (data.content.image) {
          data.content.image.pic_url = data.content.image.img_url
          data.attachments = [
            {
              msgtype: 'image',
              image: data.content.image
            }
          ]
        } else if (data.content.link) {
          data.attachments = [
            {
              msgtype: 'link',
              link: data.content.link
            }
          ]
        } else if (data.content.miniprogram) {
          data.attachments = [
            {
              msgtype: 'miniprogram',
              miniprogram: data.content.miniprogram
            }
          ]
        } else {
          data.attachments = []
        }

        console.log(data, '处理过的接口返回数据')
        this.form = data
      }
      // 重新处理表单数据
      this.guideData(data)
    },

    // 处理导购数据
    guideData (data) {
      if (data.salesperson.length > 0) {
        data.salesperson.map((v) => {
          v.name = v.salesperson_name
          v.userid = v.salesperson_id
        })
      }
      if (data.store.length > 0) {
        data.store.map((v) => {
          (v.id = v.store_id), (v.name = v.store_name)
        })
      }
      // 回显数据
      this.callData = {
        storeList: data.store,
        userList: data.salesperson
      }
      // 展示的两条数据
      this.showList = [].concat(data.salesperson, data.store).slice(0, 2)
      // 获取表单的id值
      this.getIds(this.callData)
    },

    // 获取表单的导购和门店id值
    getIds (data) {
      let userListId = []
      let storeList = []
      data.userList.forEach((v) => {
        userListId.push(v.work_userid)
      })
      data.storeList.forEach((v) => {
        storeList.push(v.id)
      })
      this.form.work_userid = userListId
      this.form.store_id = storeList
    },

    async onSubmit () {
      this.loading = true
      const { work_userid, store_id, text_msg, msg_type, channel_source, target } = this.form
      let params = {
        work_userid,
        store_id,
        text_msg,
        msg_type,
        content: {},
        channel_source,
        target
      }

      if (this.form.attachments && this.form.attachments.length > 0) {
        // 兼容老数据
        let attachment = this.form.attachments[0]
        if (attachment.msgtype === 'image') {
          attachment.image.img_url = attachment.image.pic_url
        }
        params.content[attachment.msgtype] = attachment[attachment.msgtype]
      }

      const data = await this.$api.customerConversion
        .saveWelcome(this.welcomeMsgId, params)
        .catch(() => {
          this.loading = false
        })

      if (data) {
        this.loading = false
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.$router.push({ path: '/customerConversion/welcomeLanguage', replace: true })
      }
    },
    getUserList (e) {
      if (e.userList.length > 0) {
        e.userList.map((v) => {
          v.salesperson_name = v.name
        })
      }

      this.callData = e
      this.showList = [].concat(e.userList, e.storeList).slice(0, 2)
      this.getIds(e)
    }
  }
}
</script>
<style lang="css">
.el-tabs__nav-wrap {
  padding-left: 20px;
}
</style>
<style lang="scss" scoped>
.el-divider--horizontal {
  margin-top: 10px;
}

.guide-box {
  display: flex;
  align-items: center;
  width: auto;
  .guide-number {
    display: flex;
    align-items: center;
    .pic {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 4px;
      border-radius: 50%;
    }
    margin-right: 10px;
  }
  .guide-deparment {
    display: flex;
    align-items: center;
    .pic-folder {
      display: inline-block;
      width: 18px;
      height: 18px;
      background: url('../../assets/img/folder.png') no-repeat;
      background-size: contain;
      margin-right: 4px;
    }
  }
}
.welcome-box {
  background-color: #fff;
  margin-bottom: 20px;
}
</style>
